"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SankeyModalWelcome = void 0;
// Standard lib
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
// Imported libs
const react_2 = require("@chakra-ui/react");
const SankeyUtils_1 = require("../configmenus/SankeyUtils");
const react_draggable_1 = __importDefault(require("react-draggable"));
const SankeyModalWelcome = (t, active_page, set_active_page, dict_hook_ref_setter_show_dialog_components, never_see_again, additional_shortcut_item, external_pagination, external_content) => {
    const [show_wecome, set_show_welcome] = (0, react_1.useState)(!never_see_again.current);
    dict_hook_ref_setter_show_dialog_components.ref_setter_show_modal_welcome.current = set_show_welcome;
    const content_rc_static = react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.Heading, { variant: 'heading_welcome_style' }, t('Menu.rcc_titre_princ')),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, t('Menu.rcc_cdn_bold')),
            t('Menu.rcc_cdn')),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, t('Menu.rcc_ctrl_scrll_bold')),
            t('Menu.rcc_ctrl_scrll')),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, t('Menu.rcc_F7_bold')),
            t('Menu.rcc_F7')),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, t('Menu.rcc_F8_bold')),
            t('Menu.rcc_F8')),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, t('Menu.rcc_F9_bold')),
            t('Menu.rcc_F9')));
    const content_rc_not_static = react_1.default.createElement(react_2.Accordion
    // className='accordion_new_welcome'
    , { 
        // className='accordion_new_welcome'
        defaultIndex: 0, allowToggle: true },
        react_1.default.createElement(react_2.AccordionItem
        // eventKey='OS'
        , null,
            react_1.default.createElement(react_2.AccordionButton, null,
                react_1.default.createElement(react_2.Box, { as: 'span', layerStyle: 'menuconfig_entry' }, t('Menu.rcc_titre_princ')),
                react_1.default.createElement(react_2.AccordionIcon, null)),
            react_1.default.createElement(react_2.AccordionPanel, null,
                react_1.default.createElement(react_2.Heading, { variant: 'heading_welcome_style' },
                    t('Menu.rcc_titre_select'),
                    ":"),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null, t('Menu.rcc_cn_bold')),
                    t('Menu.rcc_cn')),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null, t('Menu.rcc_ctrl_cn_bold')),
                    t('Menu.rcc_ctrl_cn')),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null, t('Menu.rcc_cf_bold')),
                    t('Menu.rcc_cf')),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null, t('Menu.rcc_ctrl_cf_bold')),
                    t('Menu.rcc_ctrl_cf')),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null, t('Menu.rcc_cs_bold')),
                    t('Menu.rcc_cs')),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null, t('Menu.rcc_click_and_drag_bold')),
                    t('Menu.rcc_click_and_drag')),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null, t('Menu.rcc_cdn_bold')),
                    t('Menu.rcc_cdn')),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null, t('Menu.rcc_ad_bold')),
                    t('Menu.rcc_ad')),
                react_1.default.createElement("hr", { style: { borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 2 } }),
                react_1.default.createElement(react_2.Heading, { variant: 'heading_welcome_style' },
                    t('Menu.rcc_titre_edi'),
                    " :"),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null, t('Menu.rcc_e_cn_bold')),
                    t('Menu.rcc_e_cn')),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null, t('Menu.rcc_e_ds_bold')),
                    t('Menu.rcc_e_ds')),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null, t('Menu.rcc_e_dn_bold')),
                    t('Menu.rcc_e_dn')),
                react_1.default.createElement("hr", { style: { borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 2 } }),
                react_1.default.createElement(react_2.Heading, { variant: 'heading_welcome_style' },
                    t('Menu.rcc_titre_autre'),
                    " :"),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null, t('Menu.rcc_a_s_bold')),
                    t('Menu.rcc_a_s')),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null, t('Menu.rcc_a_fc_bold')),
                    t('Menu.rcc_a_fc')),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null, t('Menu.rcc_a_dbm_bold')),
                    t('Menu.rcc_a_dbm')),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null, t('Menu.rcc_a_ech_bold')),
                    t('Menu.rcc_a_ech')),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null, t('Menu.rcc_ctrl_scrll_bold')),
                    t('Menu.rcc_ctrl_scrll')),
                react_1.default.createElement("hr", { style: { borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 2 } }))),
        additional_shortcut_item);
    external_content['rc'] = SankeyUtils_1.windowSankey.SankeyToolsStatic ? content_rc_static : content_rc_not_static;
    const content = react_1.default.createElement("div", { style: { height: window.innerHeight * 0.65, overflowY: 'auto' } }, external_content[active_page]);
    const welcome_footer = react_1.default.createElement(react_bootstrap_1.Modal.Footer, { style: { justifyContent: 'center' } },
        react_1.default.createElement(react_bootstrap_1.Pagination, null, external_pagination.map((c, i) => { return react_1.default.createElement(react_1.default.Fragment, { key: i }, c); })),
        react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', label: t('dontSeeAgain'), checked: never_see_again.current, onChange: evt => {
                never_see_again.current = evt.target.checked;
                localStorage.setItem('dontSeeAggainWelcome', '1');
                dict_hook_ref_setter_show_dialog_components.ref_setter_show_modal_welcome.current(false);
            } }));
    const class_name = t('welcome.' + active_page).replaceAll('/', '').replaceAll('.', '').replaceAll('\'', '').split(' ').join('_');
    const n_style_menu_draggable = JSON.parse(JSON.stringify(style_menu_draggable));
    n_style_menu_draggable.width = '75%';
    return react_1.default.createElement(react_draggable_1.default, { handle: '.title_menu', defaultPosition: { x: window.innerWidth / 8, y: window.innerHeight * 0.12 }, bounds: { left: 0, top: 0 } },
        react_1.default.createElement("div", { hidden: !show_wecome || never_see_again.current, className: 'menu_conf ' + class_name, style: n_style_menu_draggable },
            react_1.default.createElement(react_bootstrap_1.Row, { className: 'title_menu', style: { 'borderBottom': ' 1px solid #eceeef', 'lineHeight': '1.5rem', 'zIndex': '3', 'backgroundColor': 'white', 'position': 'sticky', 'top': '0', 'padding': '1rem' } },
                react_1.default.createElement(react_bootstrap_1.Col, null,
                    react_1.default.createElement("h3", null, t('welcome.' + active_page))),
                react_1.default.createElement(react_bootstrap_1.Col, { className: 'text-end' }, react_1.default.createElement(react_bootstrap_1.CloseButton, { onClick: () => {
                        dict_hook_ref_setter_show_dialog_components.ref_setter_show_modal_welcome.current(false);
                    } }))),
            react_1.default.createElement("div", { className: 'sankey-menu' }, content),
            welcome_footer));
};
exports.SankeyModalWelcome = SankeyModalWelcome;
const style_menu_draggable = { 'display': 'flex',
    width: '25%',
    'paddingLeft': '0.75rem',
    'paddingRight': '0.75rem',
    'position': 'fixed',
    'flexDirection': 'column',
    'backgroundColor': '#fff',
    'backgroundClip': 'padding-box',
    'border': '1px solid rgba(0, 0, 0, 0.2)',
    'borderRadius': ' 0.6rem',
    'zIndex': '2',
};
